/**
 * Image Helper Utility
 * Centralizes image URL construction and handles missing images gracefully.
 */

const API_BASE = "https://api.washim.org";

/**
 * Returns a full image URL if the path is valid, or null if missing/empty.
 * Components should render a styled placeholder when this returns null.
 * @param {string} imagePath - The image path from the database (e.g., "/TD-Images/...")
 * @returns {string|null} Full URL or null
 */
export function getTempleImageUrl(imagePath) {
  if (!imagePath || imagePath.trim() === "") {
    return null;
  }
  return `${API_BASE}${imagePath}`;
}

/**
 * Checks if a gallery array has valid (non-empty) entries.
 * @param {string[]} gallery - Array of image/video paths
 * @returns {string[]} Filtered array of valid paths
 */
export function getValidGallery(gallery) {
  if (!gallery || !Array.isArray(gallery)) return [];
  return gallery.filter(item => item && item.trim() !== "");
}

export default getTempleImageUrl;
